module.exports = __webpack_public_path__ + "static/img/service_off.1afb9ddb.svg";